import React from 'react';
import { FiAlertTriangle, FiCheck, FiInfo, FiX } from 'react-icons/fi';
import '../feedback/tones.css';

const VARIANTES = {
  success: { tone: 'success', Icon: FiCheck },
  error: { tone: 'danger', Icon: FiX },
  warning: { tone: 'warning', Icon: FiAlertTriangle },
  info: { tone: 'info', Icon: FiInfo }
};

const Toast = ({ message, description, type = 'info', duration, onClose }) => {
  const { tone, Icon } = VARIANTES[type] || VARIANTES.info;

  return (
    <div className={`toast feedback-tone--${tone}`} role="status">
      <span className="toast__icon" aria-hidden="true"><Icon /></span>
      <div className="toast__body">
        <div className="toast__title">{message}</div>
        {description && <div className="toast__description">{description}</div>}
      </div>
      <button type="button" className="toast__close" onClick={onClose} aria-label="Fechar notificação">
        ×
      </button>
      {duration > 0 && (
        <div className="toast__timer" aria-hidden="true" style={{ animationDuration: `${duration}ms` }} />
      )}
    </div>
  );
};

export default Toast;
